import { useEffect, useState } from 'react';

/**
 * Ein Wert, der erst nach einer Ruhepause weitergereicht wird.
 *
 * 180 ms: kuerzer als eine Denkpause beim Tippen, laenger als der Abstand
 * zwischen zwei Anschlaegen. Ohne das loeste jeder Tastendruck eine Abfrage
 * aus -- "Drucker" waeren sieben.
 *
 * Stand bis zur Autovervollstaendigung in der Befehlspalette; seitdem teilen
 * sich die Palette und jedes Nachschlagefeld denselben Takt.
 */
export function useDebounced<T>(value: T, delay = 180): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const handle = window.setTimeout(() => {
      setSettled(value);
    }, delay);
    return () => {
      window.clearTimeout(handle);
    };
  }, [value, delay]);

  return settled;
}
